import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
	padding-bottom: 1rem;
`;

export const firstTitle = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 10px;
	padding-bottom: 10px;
	border-bottom: 1px solid ${color.interface.lightGray2};

	> p {
		color: ${color.interface.darkgray};
		width: 100%;
		font-family: nunito-bold;
		font-size: 1.5rem;
		text-align: center;
	}

	> svg {
		position: absolute;
		left: 8px;
		min-width: 20px;
		min-height: 20px;
		color: #4f2170;
	}
`;

export const secondTitle = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;

	> p {
		font-family: nunito-bold;
		font-size: 1.5rem;
		text-align: center;
	}
`;

export const roundImg = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;

	> img {
		width: 100%;
		min-height: 50px;
		border-radius: 5px;
	}
`;

export const fullImg = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;

	> img {
		width: 100%;
		min-height: 50px;
	}
`;

export const noData = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;

	> p {
		font-family: nunito-bold;
		font-size: 1.5rem;
	}
`;

export const box = styled.div`
	width: 100%;
	padding: 0 8px;
`;

export const footer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;

	> h2 {
		text-align: center;
		opacity: 0.9;
		font-size: 1.4rem;
		font-family: nunito-bold;
	}

	> p {
		text-align: justify;
		opacity: 0.9;
	}
`;
